import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  paperMobile: {
    color: '#FFFFFF',
    backgroundColor: `${fade("#263593", 0.6)}`,
    fontSize: '0.875rem',
    lineHeight: '1.125rem',
    padding: 8,
  },
  box: { display: 'flex', alignItems: 'center' },
  boxName: {
    flex: '1 1 auto',
    padding: '0 12px 0 8px',
    fontWeight: 600,
    '& .days': { fontSize: '0.8125rem', lineHeight: '1rem', fontWeight: 500 },
  },
  boxFix: { flex: '0 0 auto' },
  iconMore: {
    fontSize: '1.5rem',
  },
  iconButton: {
    padding: 0,
    color: '#FFFFFF',
  },
  popper: {
    zIndex: 3,
  },
  paperPopup: {
    minWidth: '125px',
    maxWidth: '125px',
    marginTop: '8px',
    boxShadow: '0px 0px 10px rgba(74, 74, 74, 0.25)',
    borderRadius: 5,
  },
  rootList: {
    padding: '4px',
  },
  rootListItem: {
    color: '#4A4A4A',
    padding: '8px',
    '&:hover': {
      backgroundColor: '#FFF',
      color: '#4A4A4A',
      borderRadius: 5,
    },
  },
  rootListItemText: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: '1rem',
  },
  avatar: {
    width: '28px',
    height: '28px',
    padding: '4px',
    backgroundColor: '#5791be',
  },
  avatarIcon: {
    fontSize: '1.25rem !important',
    color: '#9B9B9B',
  },
  logo:{
    minWidth: '40px',
    maxWidth: '40px',
    minHeight: '40px',
    maxHeight: '40px',
  },
  eventBox:{
    margin: '0 -16px',
    display:'table',
    borderCollapse: 'separate', 
    borderSpacing: '16px 0', 
    fontFamily: 'Montserrat, "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif',
    textTransform: 'uppercase',
    [theme.breakpoints.down("sm")]: {
      margin: '16px -16px 0 -16px',
    },
  },
  eventBoxDate:{
    padding: 16,
    display:'table-cell',
    verticalAlign:'middle',
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    letterSpacing: '0.5px',
    textAlign:'center',
    color: '#FFF',
    backgroundColor: `${fade("#263593", 0.6)}`,
    borderRadius: 20,
    '& .days': {
      fontSize: '1.875rem',
      lineHeight: '1.5rem',
    },
    '& .day': {},
  },
  eventBoxName:{
    padding: 16,
    width: '100%',
    display:'table-cell',
    verticalAlign:'middle',
    fontWeight: 600,
    fontSize: '1.75rem',
    lineHeight: '2.375rem',
    color: '#FFF',
    borderRadius: 20,
    backgroundColor: `${fade("#263593", 0.6)}`,
    [theme.breakpoints.down("sm")]: {
      fontSize: '1.5rem',
      lineHeight: '2rem',
      fontWeight: 'normal',
    },
  },
}))

export default useStyles
